<template>
  <div class="order-input day">
    <select name="day" id="day" v-model="date" ref="dateField">
      <option v-for="date in availableDates" :key="date.value" :value="date.value">
        {{ date.label }}
      </option>
    </select>
  </div>
</template>

<script>
import dateMixins from '@apps/order-form/src/mixins/date'

export default {
  name: 'Date',
  mixins: [dateMixins],
}
</script>
